import { c as _c } from "react/compiler-runtime";
import Head from "next/head";
export default function OfflinePage() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Head><title>Offline</title></Head>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<div className="px-[20px] pt-40"><h1 className="mb-4 text-pretty text-3xl font-semibold">You are offline</h1><p className="mb-8 text-lg">Check your internet connection and try again.</p></div></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}